import MailTemplates    from "../../../../domain/mail/template/MailTemplates";
import ResKaReduxAction from "../../ResKaReduxAction";

export enum ACTION_TYPE {
  SET_MAIL_TEMPLATES = "SET_MAIL_TEMPLATES",
}

export interface SetMailTemplatesAction extends ResKaReduxAction{
  mailTemplates: MailTemplates;
}

export type MailTemplatesAction = SetMailTemplatesAction;

export const setMailTemplatesAction = (mailTemplates: MailTemplates): SetMailTemplatesAction => ({
  type: ACTION_TYPE.SET_MAIL_TEMPLATES,
  mailTemplates: mailTemplates,
});